import { supportsBarcodeDetector } from './utils/feature_detection';

if (!('scrollBehavior' in document.documentElement.style)) {
  import('smoothscroll-polyfill')
    .then((module) => {
      (module.default || module).polyfill();
    })
    .catch(() => {
      // Intentionally empty
    });
}

if (!supportsBarcodeDetector) {
  import('barcode-detector')
    .then((module) => {
      window.BarcodeDetector = module.default || module;
    })
    .catch(() => {
      // Intentionally empty
    });
}
